import { render, staticRenderFns } from "./editRolePermission.vue?vue&type=template&id=0a9d359a"
import script from "./editRolePermission.vue?vue&type=script&lang=js"
export * from "./editRolePermission.vue?vue&type=script&lang=js"
import style0 from "./editRolePermission.vue?vue&type=style&index=0&id=0a9d359a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports